Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionCreator = void 0;

exports.actionCreator = function (state, dispatch) {
  var setActiveTheme = function setActiveTheme(themeId) {
    dispatch({
      type: 'SET_ACTIVE_THEME',
      themeId: themeId
    });
  };

  var setTemporaryActiveTheme = function setTemporaryActiveTheme(themeId) {
    dispatch({
      type: 'SET_TEMPORARY_ACTIVE_THEME',
      themeId: themeId
    });
  };

  var setLastTheme = function setLastTheme() {
    dispatch({
      type: 'SET_LAST_THEME'
    });
  };

  return {
    setActiveTheme: setActiveTheme,
    setLastTheme: setLastTheme,
    setTemporaryActiveTheme: setTemporaryActiveTheme
  };
};